/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
import React, { Component } from 'react';
import { AutoSizer, Table, Column } from 'react-virtualized';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import $ from 'jquery';
import { List, Icon } from 'semantic-ui-react';

class TabRowComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePopup: false,
      activePopupIndex: '',
      searchVersion: '',
      searchFileName: '',
      searchScanPath: '',
    };
    this.clearSearch = this.clearSearch.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleChangeVersion = this.handleChangeVersion.bind(this);
    this.handleChangeFileName = this.handleChangeFileName.bind(this);
    this.handleChangeScanPath = this.handleChangeScanPath.bind(this);
    this.handleVersionKeyPress = this.handleVersionKeyPress.bind(this);
    this.handleFileNameKeyPress = this.handleFileNameKeyPress.bind(this);
    this.handleScanPathKeyPress = this.handleScanPathKeyPress.bind(this);
    this.updateSearchValue = this.updateSearchValue.bind(this);
  }

  componentDidMount() {
    this.updateSearchValue();
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleChangeVersion = (event) => {
    this.setState({ searchVersion: event.target.value });
  };

  handleChangeFileName = (event) => {
    this.setState({ searchFileName: event.target.value });
  };

  handleChangeScanPath = (event) => {
    this.setState({ searchScanPath: event.target.value });
  };

  handleVersionKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchVersionString(event.target.value);
    }
  }

  handleFileNameKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchFileNameString(event.target.value);
    }
  }

  handleScanPathKeyPress(event) {
    if (event.key === 'Enter') {
      this.searchScanPathString(event.target.value);
    }
  }

  handleClickOutside(event) {
    const { activePopup, activePopupIndex } = this.state;
    const container = $('.match_detail .custom_popup');
    if (container && container.has(event.target).length === 0) {
      if (activePopup && activePopupIndex !== '') {
        this.setState({
          activePopup: false,
          activePopupIndex: '',
        });
      }
    }
  }

  /*
  handlePopupToggle = (value) => {
    const { activePopup, activePopupIndex } = this.state;

    if (activePopup && activePopupIndex === value) {
      return this.setState({
        activePopup: false,
        activePopupIndex: '',
      });
    }

    this.setState({
      activePopup: true,
      activePopupIndex: value,
    });
  };
  */

  searchVersionString = (value) => {
    const { matchesData, currentIndex, updateHashCallback } = this.props;
    const newData = {};

    // eslint-disable-next-line no-unused-vars
    Object.entries(matchesData).forEach(([key, lists]) => {
      lists.forEach((list) => {
        if (list.version.toLowerCase().includes(value.toLowerCase())) {
          newData[list.version] = newData[list.version] || [];
          newData[list.version].push(list);
        }
      });
    });

    const obj = {
      type: 'version',
      backup_data: matchesData,
      update_data: newData,
      value,
      index: currentIndex,
    };

    updateHashCallback(obj);
  };

  searchFileNameString = (value) => {
    const { matchesData, currentIndex, updateHashCallback } = this.props;
    const newData = {};

    // eslint-disable-next-line no-unused-vars
    Object.entries(matchesData).forEach(([key, lists]) => {
      lists.forEach((list) => {
        if (list.crawled_file.toLowerCase().includes(value.toLowerCase())) {
          if (!newData[list.version]) {
            newData[list.version] = [];
          }
          newData[list.version].push(list);
        }
      });
    });

    const obj = {
      type: 'crawled_file',
      backup_data: matchesData,
      update_data: newData,
      value,
      index: currentIndex,
    };

    updateHashCallback(obj);
  };

  searchScanPathString = (value) => {
    const { matchesData, currentIndex, updateHashCallback } = this.props;
    const newData = {};

    Object.entries(matchesData).forEach(([key, lists]) => {
      lists.forEach((list) => {
        if (list.scanned_file.toLowerCase().includes(value.toLowerCase())) {
          if (!newData[list.version]) {
            newData[list.version] = [];
          }
          newData[list.version].push(list);
        }
      });
    });

    const obj = {
      type: 'scanned_file',
      backup_data: matchesData,
      update_data: newData,
      value,
      index: currentIndex,
    };

    updateHashCallback(obj);
  };

  copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  updateSearchValue() {
    const {
      versionValue, fileNameValue, currentIndex, setActiveValue, scanPathValue
    } = this.props;
    if (versionValue !== '') {
      this.setState({ searchVersion: versionValue });
    }

    if (fileNameValue !== '') {
      this.setState({ searchFileName: fileNameValue });
    }

    if (scanPathValue !== '') {
      this.setState({ searchScanPath: scanPathValue });
    }

    if (localStorage.getItem('matched_detail') === null) {
      this.setState({
        searchVersion: '',
        searchFileName: '',
        searchScanPath: '',
      });
    }
    setActiveValue(currentIndex, 'hash_matches');
  }

  clearSearch() {
    const { clearDetailedSearch, currentTab } = this.props;
    if (localStorage.getItem('matched_detail') !== null) {
      this.setState({
        searchVersion: '',
        searchFileName: '',
        searchScanPath: '',
      });
      return clearDetailedSearch(currentTab);
    }
    this.setState({
      searchVersion: '',
      searchFileName: '',
      searchScanPath: '',
    });
  }

  render() {
    const {
      matchesData,
      translate,
      currentTab,
      versionCount,
      crawledFileNameCount,
      hashCount,
      scannedFileNameCount
    } = this.props;
    const {
      activePopup, activePopupIndex, searchVersion, searchFileName, searchScanPath
    } = this.state;

    let flattenedData = Object.keys(matchesData).reduce((acc, version) => {
      const items = matchesData[version].map((item) => { return { ...item, version }; });
      return acc.concat(items);
    }, []);

    flattenedData = [{ isInputRow: true, id: 'inputRow-0' }, ...flattenedData];

    return (
      <AutoSizer>
        {({ width, height }) => {
          return (
            <Table
              width={width}
              height={height}
              headerHeight={25}
              rowHeight={80}
              rowCount={flattenedData.length}
              rowGetter={({ index }) => { return flattenedData[index]; }}
            >
              <Column
                label={translate('list.title.version')}
                dataKey="version"
                width={90}
                headerRenderer={() => {
                  return (
                    <div>
                      {`${translate('list.title.version')}(${versionCount})`}
                    </div>
                  );
                }}
                cellRenderer={({ cellData, rowData }) => {
                  if (rowData.isInputRow) {
                    return (
                      <div className="row_saerch_wrap">
                        <input
                          className="text"
                          style={{ lineHeight: '28px', height: '28px', fontSize: '12px' }}
                          value={searchVersion}
                          placeholder={translate('list.title.version')}
                          onChange={this.handleChangeVersion}
                          onKeyPress={this.handleVersionKeyPress}
                        />
                        <a
                          className="reset_icon"
                          onClick={this.clearSearch}
                          onKeyUp={this.clearSearch}
                        >
                          x
                        </a>
                      </div>
                    );
                  }
                  return (
                    <div className="table-cell-wrapper">
                      {rowData.version && <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.version); }} style={{ cursor: 'pointer' }} />}
                      <span className="table-cell">{rowData.version}</span>
                    </div>
                  );
                }}
              />
              <Column
                label={translate('list.title.matched_crawled_file_name')}
                dataKey="crawled_file"
                width={220}
                headerRenderer={() => {
                  return (
                    <span>
                      {`${translate('list.title.matched_crawled_file_name')}(${crawledFileNameCount})`}
                    </span>
                  );
                }}
                cellRenderer={({ cellData, rowData, rowIndex }) => {
                  if (rowData.isInputRow) {
                    return (
                      <div className="row_saerch_wrap">
                        <input
                          className="text"
                          style={{ lineHeight: '28px', height: '28px', fontSize: '12px' }}
                          value={searchFileName}
                          placeholder={translate('list.title.matched_crawled_file_name')}
                          onKeyPress={this.handleFileNameKeyPress}
                          onChange={this.handleChangeFileName}
                        />
                        <a
                          className="reset_icon"
                          onClick={this.clearSearch}
                          onKeyUp={this.clearSearch}
                        >
                          x
                        </a>
                      </div>
                    );
                  }
                  return (
                    <div
                      className={cx('table-cell-wrapper custom_popup', {
                        show: activePopup && activePopupIndex === `${rowData.checksum}_${rowIndex}`,
                      })}
                    >
                      <div
                        //className="table-cell has_link"
                        className="table-cell"
                        //onClick={() => {
                        //return this.handlePopupToggle(`${rowData.checksum}_${rowIndex}`);
                        //}}
                        //onKeyUp={() => {
                        //return this.handlePopupToggle(`${rowData.checksum}_${rowIndex}`);
                        //}}
                      >
                        {
                          rowData.crawled_file && <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.crawled_file); }} style={{ cursor: 'pointer' }} />
                        }
                        <span>{rowData.crawled_file}</span>
                      </div>
                      <div className="crawded_info">
                        <List>
                          <List.Item>
                            <List.Header style={{ fontSize: '11px' }}>
                              <List.Icon name="info circle" />
                              {translate('modal.title.crawled_file_name')}
                              {' '}
                            </List.Header>
                            <List.Content style={{ fontSize: '11px' }}>{rowData.crawled_file_name}</List.Content>
                          </List.Item>
                        </List>
                      </div>
                    </div>
                  );
                }}
              />
              {
                currentTab === 'hash_matches'
                && (
                  <Column
                    label={translate('settings.list.sha256')}
                    dataKey="checksum"
                    width={350}
                    headerRenderer={() => {
                      return (
                        <span>
                          {`${translate('settings.list.sha256')}(${hashCount})`}
                        </span>
                      );
                    }}
                    cellRenderer={({ cellData, rowData }) => {
                      if (rowData.isInputRow) {
                        return (<div />);
                      }
                      return (
                        <div className="table-cell-wrapper">
                          {
                            rowData.checksum && <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.checksum); }} style={{ cursor: 'pointer' }} />
                          }
                          <span className="table-cell">
                            {rowData.checksum}
                          </span>
                        </div>
                      );
                    }}
                  />
                )
              }
              <Column
                label={translate('list.title.matched_scanned_file_name')}
                dataKey="scanned_file"
                width={170}
                headerRenderer={() => {
                  return (
                    <span>
                      {`${translate('list.title.matched_scanned_file_name')}(${scannedFileNameCount})`}
                    </span>
                  );
                }}
                cellRenderer={({ cellData, rowData }) => {
                  if (rowData.isInputRow) {
                    return (
                      <div className="row_saerch_wrap">
                        <input
                          className="text"
                          style={{ lineHeight: '28px', height: '28px', fontSize: '12px' }}
                          value={searchScanPath}
                          placeholder={translate('list.title.matched_scanned_file_name')}
                          onKeyPress={this.handleScanPathKeyPress}
                          onChange={this.handleChangeScanPath}
                        />
                        <a
                          className="reset_icon"
                          onClick={this.clearSearch}
                          onKeyUp={this.clearSearch}
                        >
                          x
                        </a>
                      </div>
                    );
                  }
                  return (
                    <div className="table-cell-wrapper extracted_file">
                      {rowData.scanned_file && <Icon name="copy outline" onClick={() => { return this.copyToClipboard(rowData.scanned_file); }} style={{ cursor: 'pointer' }} />}
                      <span className="table-cell">{rowData.scanned_file}</span>
                    </div>
                  );
                }}
              />
            </Table>
          );
        }}
      </AutoSizer>
    );
  }
}
export default TabRowComponent;
